/* eslint-disable simple-import-sort/imports */
/* eslint-disable curly */
// This code is generated automatically. Do not modify it manually.
// The suppressions below are required to suppress false positive ESLint warnings.
//
// Generated: Mon, 27 Jul 2026 15:46:33 GMT
//
// noinspection RedundantIfStatementJS, JSUnusedGlobalSymbols, DuplicatedCode
//
import { CopDocumentType } from '@/types/copDocumentType';

const valuesOfCopDocumentType: readonly string[] = ['CC', 'CE', 'NIT', 'PASS', 'PEP', ''];

export const isCopDocumentType = (value: unknown): value is CopDocumentType => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfCopDocumentType.includes(value);
};

export const isCopDocumentTypeOrNull = (value: unknown): value is CopDocumentType | null => {
  return value === null || isCopDocumentType(value);
};

export const isArrayOfCopDocumentType = (value: unknown): value is CopDocumentType[] => {
  return Array.isArray(value) && value.every(isCopDocumentType);
};

export const isArrayOfCopDocumentTypeOrNull = (
  value: unknown,
): value is CopDocumentType[] | null => {
  return value === null || isArrayOfCopDocumentType(value);
};
